import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { NetworkReputationReport } from "../@types/Url";
import api from "../api";
import { USEQUERY_DISABLE_REFETCH_OPTIONS } from "../consts";
import { ErrorResponse, MessageErrorResponse } from "../../../requests/@types";

const useNetworkReputation = (values: Array<string> = []) => {
  const { data, isFetching, isError, error } = useQuery<
    NetworkReputationReport,
    ErrorResponse<MessageErrorResponse>
  >({
    ...USEQUERY_DISABLE_REFETCH_OPTIONS,
    queryKey: ["urlReputation", values],
    queryFn: () =>
      api
        .urlReputation(values)
        .then((r: { data: NetworkReputationReport }) => r.data),
    placeholderData: keepPreviousData,
    enabled: Boolean(values.length)
  });

  return { data, isFetching, isError, error };
};

export default useNetworkReputation;
